module.exports = __webpack_public_path__ + "media/images/linkedin-ab58c010b694e4a9550d2a8a851673d49de71a850a751a924b63868f71cecd14.png";